import { Fragment, useEffect, useState } from "react";
import { getHTML } from "../../services/helper";
import "./Carousel.scss";

interface IProps {
    slideDelay?: number,
    linkClass?: string,
    content: {
        images: {
            url: string,
            header?: string,
            description?: string,
            caption?: {
                header?: string,
                description?: string
            }
        }[]
    }
}

const Carousel: React.FC<IProps> = (props: IProps) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => setTimeout(() => {
            if (currentImageIndex + 1 === props.content.images.length) {
                setCurrentImageIndex(0);
            }  else {
                setCurrentImageIndex( currentImageIndex + 1 );
            }
        }), (props.slideDelay || 1) * 1000);
        return () => {
          clearInterval(interval);
        };
    });

    return (
        <div id="carouselIndicators" className={'carousel slide ' + (props.linkClass)} data-ride="carousel">
            <ol className="carousel-indicators">
            {
                props.content.images.length > 0 &&
                props.content.images.map((image, index) =>
                    <li key={index} data-target="#carouselIndicators" data-slide-to={index} className={ currentImageIndex === index ? 'active' : ''} onClick={() => setCurrentImageIndex(index)}></li>
                )
            }
            </ol>
            <div className="carousel-inner">
                {
                    props.content.images.length > 0 &&
                    props.content.images.map((image, index) =>
                        <Fragment key={index}>
                            <div className={'carousel-item' + (currentImageIndex === index ? ' active' : '')}>
                                <img className="d-block w-100 image" src={image.url} alt={'slide' + (index)} />
                            </div>

                            <div className={'carousel-center-caption ' + (currentImageIndex === index ? 'd-md-block' : 'd-none')}>
                                <div className="carousel-center-caption-inner mx-auto text-center text-white px-3">
                                    {
                                        image.header &&
                                        <h1 dangerouslySetInnerHTML={getHTML(image.header)}></h1>
                                    }
                                    {
                                        image.description &&
                                        <p dangerouslySetInnerHTML={getHTML(image.description)}></p>
                                    }
                                </div>
                                {
                                    image.caption && image.caption.header &&
                                    <h5 dangerouslySetInnerHTML={getHTML(image.caption.header)}></h5>
                                }
                                {
                                    image.caption && image.caption.description &&
                                    <p dangerouslySetInnerHTML={getHTML(image.caption.description)}></p>
                                }
                            </div>
                        </Fragment>
                    )
                }
            </div>
        </div>
    );
};

export default Carousel;
